import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { formatValidTN } from "@/utils/general";

interface TNStore {
    tn: string;
    setTN: (tn: string) => void;
    clearTN: () => void;
}

const useTNStore = create<TNStore>()(
    persist(
        (set) => ({
            tn: "",
            setTN: (tn) => set(() => ({ tn: formatValidTN(tn) })),
            clearTN: () => set(() => ({ tn: "" })),
        }),
        {
            name: "tn",
            storage: createJSONStorage(() => sessionStorage),
            skipHydration: true,
        },
    ),
);

export default useTNStore;
